/**
 * Created by RoryHe on 2020/7/1.
 */
import axios from 'axios'
import * as api from './api'
import Vue from 'vue'
import {getUrlKey} from './tool'
import {funcUrlDel} from './utils'
import store from '../../store'
import router from '../../router'

function commonHeaders() {
  let {actId, brtActId, activeRole} = store.state.user;
  let system = getUrlKey('system', window.location.href);
  // 管理平台的金融机构id
  const brtManagerActId = getUrlKey('brtActId', window.location.href);
  let isBrt = system.indexOf('brt') > -1
  let operateActId = getUrlKey('id', window.location.href)
  return isBrt ? {
    userActId: system === 'brt-ag' ? brtManagerActId : brtActId,
    roleId: 'brt',
    operateActId,
  } : {
    userActId: actId,
    roleId: activeRole,
    operateActId,
  }
}


let sourceToken = axios.CancelToken.source();
// 当前请求接口数量
let loadingCount = 0;
// loading定时器
let loadingTimer = null;


const request = (data, isShowLoading, loadingText = '加载中...') => {
  if (!isShowLoading) isShowLoading = false
  if (isShowLoading && loadingCount === 0 && !loadingTimer) {
    Vue.$loading.show({content: loadingText});
  }
  if (isShowLoading && loadingTimer) {
    clearTimeout(loadingTimer);
    loadingTimer = null;
  }
  if (isShowLoading) {
    loadingCount++;
  }

  axios.defaults.withCredentials = true
  return new Promise((resolve, reject) => {
    if (!data.data) {
      data.data = {}
    }
    var method = data.method
    var axiosInstance;
    let headers = data.headers || {}
    // webrtc特殊处理, 请求头增加内容
    if (data.url.indexOf(api.rtcPrefix) !== -1) {
      const mediateToken = window._mediateToken;
      const userId = window._userId;
      const rtcHeader = {
        'rtc-auth-token': mediateToken,
        uid: userId
      }
      headers = {...headers, ...rtcHeader};
    }
    switch (method) {
      case 'POST':
        axiosInstance = axios.post(data.url, data.data, {
          cancelToken: sourceToken.token,
          headers: {
            "Accept": "application/json, text/html, */*; charset=utf-8",
            "Content-Type": "application/json",
            "content-type": "application/json",
            ...commonHeaders(),
            ...headers
          },
          timeOut: data.timeout,
          withCredentials: true,
          validateStatus: (status) => {
            return status == 200
          },
          responseType: data.responseType ? data.responseType : "json",
        })
        break
      case 'PUT':
        axiosInstance = axios.put(data.url, data.data, {
          cancelToken: sourceToken.token,
          headers: {
            "Accept": "application/json, text/html, */*; charset=utf-8",
            "Content-Type": "application/json",
            "content-type": "application/json",
            ...headers
          },
          timeOut: data.timeout,
          withCredentials: true,
          validateStatus: (status) => {
            return status == 200
          },
          responseType: data.responseType ? data.responseType : "json",
        })
        break
      case 'DELETE':
        axiosInstance = axios.delete(data.url, data.data, {
          cancelToken: sourceToken.token,
          headers: {
            "Accept": "application/json, text/html, */*; charset=utf-8",
            "Content-Type": "application/json",
            "content-type": "application/json",
            ...headers
          },
          timeOut: data.timeout,
          withCredentials: true,
          validateStatus: (status) => {
            return status == 200
          },
          responseType: data.responseType ? data.responseType : "json",
        })
        break
      case 'GET':
        var timeOut = data.timeout
        var responseType = data.responseType ? data.responseType : "json"
        if (data.paramsType == 'JSON') {
          axios.defaults.headers.post['Content-Type'] = 'application/json'
          axios.defaults.headers.post['content-type'] = 'application/json'
        }
        axios.defaults.headers.post['Accept'] = 'application/json, text/html, */*; charset=utf-8'

        Object.keys(headers).forEach(key => {
          axios.defaults.headers[key] = headers[key]
        })
        var axiosConfig = {
          cancelToken: sourceToken.token,
          url: data.url,
          method: method,
          responseType: responseType,
          timeout: timeOut,
          withCredentials: true,
          validateStatus: (status) => {
            return status == 200
          },
          headers: commonHeaders(),
          data: data.paramsType == 'JSON' ? data.data : null,
          params: data.paramsType == 'urlParams' ? data.data : null
        }
        axiosInstance = axios.request(axiosConfig)
        break
    }

    //构造请求
    axiosInstance.then(res => {
      // if (isShowLoading) {
      //   Vue.$loading.hide()
      // }
      // 关闭弹框
      closeLoading(isShowLoading);
      if (data.responseType) {
        switch (data.responseType) {
          case 'arraybuffer':
            return resolve(res)
          default:
            return resolve(res.data)
        }
      } else if (res.data) {
        const {code, msg} = res.data;
        if (code && code.toString() === '10403') {
          // 没权限
          abort();
          // 通知下去更新权限点
          Vue.prototype.$bus.$emit('UPDATE_RIGHT');
        } else if(code && code.toString() === '12404'){
          Vue.prototype.$bus.$emit('goBack');
        }
        return resolve(res.data)
      } else {
        return resolve(res)
      }
    }).catch((err) => {
      console.log('err', err)
      // 关闭弹框
      closeLoading(isShowLoading);

      if (data.responseType == 'arraybuffer') {
        try {
          let buffer = new Uint8Array(err.response.data)
          let decoder = new TextDecoder('utf-8')
          err.response.data = decoder.decode(buffer)
          err.response.data = JSON.parse(err.response.data)
        } catch (e) {
          return reject(e)
        }
      }

      if (err && err.response && err.response.status && err.response.data) {
        if ((err.response.status == 500 || err.response.status == 403) && err.response.data && err.response.data.data && err.response.data.data.gw_code == 401) {
          abort();
          sessionStorage.clear()
          // 跳转到登录
          const loginUrl = getLoginUrl();
          window.location.href = loginUrl;
        } else if (err.response.status == 403) {
          // Vue.$bus.$emit('goHome')
          const message = err.response.data.msg ? err.response.data.msg : '您没有对应的权限，请不要非法请求';
          if(message === '当前用户无失联修复功能权限，请联系管理员。'){
            Vue.prototype.$bus.$emit('goBack');
            return reject(err.response.data)
          }
          Vue.prototype.$confirm(message, '提示',{
            showCancelButton: false,
            closeOnClickModal: false,
            showClose: false
          }).then(() => {
            api.getLoginUser().then(response => {
              // 获取当前登录接口地址
              const loginUrl = getLoginUrl();
              if (response && response.code === 200) {
                const result = response.data;
                const roleMaps = result.roleMaps;
                if (Object.keys(roleMaps).length > 0) {
                  // 如果机构数量大于0，则跳转到首页。
                  clickHome()
                } else {
                  sessionStorage.clear()
                  // 否则退出
                  window.location.href = api.loginOut + window.encodeURIComponent(loginUrl);
                }
              } else {
                sessionStorage.clear()
                // 退出
                window.location.href = api.loginOut + window.encodeURIComponent(loginUrl);
              }
            })
          });
          // Message.error("您没有对应的权限，请不要非法请求");
        }
        return reject(err.response.data)
      } else {
        return reject(err ? err : '')
      }

    })
  })
}

// 关闭弹框
function closeLoading(isShowLoading) {
  if (!isShowLoading) {
    return false;
  }
  loadingCount--;
  if (loadingCount <= 0) {
    if (loadingTimer) {
      clearTimeout(loadingTimer);
      loadingTimer = null;
    }
    // 虽然是0ms，但是间隔还是有个一百左右。
    loadingTimer = setTimeout(() => {
      clearTimeout(loadingTimer);
      loadingTimer = null;
      Vue.$loading.hide();
    }, 0);
  }
}

// 获取登录地址url
export const getLoginUrl = () => {
  let url = window.location.href
  //增加登录埋点透传参数cn／co
  let reportParams = ''
  //区分运营平台（机构共用页面）、保融通平台（代理人调解）的跳转登录逻辑／参数
  let system = getUrlKey('system', window.location.href)
  let style = getUrlKey('style', window.location.href)
  let _channel = getUrlKey('_channel', window.location.href)
  // if (!style) style = 'brt-tj'
  if (!style) style = ''
  let redirectUrl = api.BASE_URL;
  if (window.project_config) {
    redirectUrl = window.project_config.getConfig('setRedirectUrl', system, style, redirectUrl, process.env.HOST, _channel)
    console.log('setRedirectUrl---', redirectUrl)
  }

  console.log('setRedirectUrl--setChannelUrl', redirectUrl)

  if (Vue.prototype.$reportJs) {
    reportParams += redirectUrl.indexOf('?') == -1 ? '?' : '&'
    reportParams += Vue.prototype.$reportJs._cn ? 'cn=' + Vue.prototype.$reportJs._cn : 'cn='
    reportParams += Vue.prototype.$reportJs._co ? '&co=' + Vue.prototype.$reportJs._co : '&co='
  }
  url = api.BASE_REDIRECT_URL + '/api/v1/login?redirectUrl=' + window.encodeURIComponent(redirectUrl + reportParams)
  console.log('url', url, 'redirectUrl', redirectUrl)
  return url;
}


function clickHome() {
  abort()
  sessionStorage.clear()
  let {origin, href, pathname} = window.location
  let url = href
  let params = funcUrlDel('id').split('?')[1] || ''
  if (pathname.indexOf('brt') > -1) {
    url = origin + '/home?' + params
  } else if (pathname.indexOf('tj') > -1) {
    url = origin + '/tj?' + params
  }
  location.href = url
}

function abort() {
  if (sourceToken) {
    sourceToken.cancel('取消请求')
    sourceToken = axios.CancelToken.source()
  }
}

export const apiGET = (url, data, isShowLoading, paramsType, responseType, timeOut, headers) => {
  return request({
    method: 'GET',
    url,
    data,
    paramsType: paramsType ? paramsType : 'urlParams',
    responseType: responseType,
    timeout: timeOut || '10000',
    headers: headers || {}
  }, isShowLoading)
}

export const downLoadGET = (url, data, isShowLoading, paramsType, responseType, timeOut) => {
  return request({
    method: 'GET',
    url,
    data,
    paramsType: paramsType ? paramsType : 'urlParams',
    responseType: responseType,
    timeout: timeOut ? timeOut : '10000',
  }, isShowLoading)
}

export const apiPOST = (url, data, isShowLoading, paramsType, responseType, timeOut, headers) => {
  return request({
    method: 'POST',
    url,
    data,
    paramsType: paramsType ? paramsType : 'JSON',
    timeout: '10000',
    headers: headers || {}
  }, isShowLoading)
}

export const apiPUT = (url, data, isShowLoading, loadingText, paramsType, responseType, timeOut, headers) => {
  return request({
    method: 'PUT',
    url,
    data,
    paramsType: paramsType ? paramsType : 'JSON',
    timeout: '10000',
    headers: headers || {}
  }, isShowLoading, loadingText)
}

export const apiDELETE = (url, data, isShowLoading, loadingText, paramsType, responseType, timeOut, headers) => {
  return request({
    method: 'DELETE',
    url,
    data,
    paramsType: paramsType ? paramsType : 'JSON',
    timeout: '10000',
    headers: headers || {}
  }, isShowLoading, loadingText)
}

export const apiUpload = (url, data, isShowLoading, paramsType) => {
  return request({
    method: 'POST',
    headers: {
      "Content-Type": 'multipart/form-data',
    },
    url,
    data,
    paramsType: paramsType ? paramsType : 'JSON',
    timeout: '10000',
  }, isShowLoading)
}

export const apiDownload = (url, data) => {
  return axios.post(url, data, {
    responseType: 'blob'
  })
}
